const reviews = [
  {
    quote: "I'm a Caledonia resident and love the small town vibe. Supporting youth football here in Caledonia is important to Godwin and I'm happy to do it!",
    name: "Scott Deboer",
    title: "Godwin Plumbing",
    initials: "SD",
  },
  {
    quote: "I grew up in Caledonia and being able to support the football program I'm so proud of brings me great joy! This community gave so much to me — it feels right to give back.",
    name: "Sarah Hoekstra",
    title: "Caledonia Resident & Sponsor",
    initials: "SH",
  },
  {
    quote: "My kids played Caledonia youth football and now I get to sponsor the next generation. I grew up in Caledonia and being able to support the football program I'm so proud of brings me great joy!",
    name: "Tom DeVries",
    title: "CYFA Alumni Parent",
    initials: "TD",
  },
  {
    quote: "Sponsoring CYFA was an easy decision. I grew up in Caledonia and being able to support the football program I'm so proud of brings me great joy — and our customers love seeing us involved.",
    name: "Lisa Brouwer",
    title: "Small Business Owner",
    initials: "LB",
  },
];

export default function SponsorReviews() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block bg-yellow-100 text-yellow-700 font-bold text-sm uppercase tracking-widest px-4 py-2 rounded-full mb-4">
            Sponsor Stories
          </span>
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-6">
            Hear From Our <span className="text-yellow-600">Sponsors</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Real words from real members of the Caledonia community who are proud to invest in our youth.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {reviews.map((review, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300 flex flex-col gap-6"
            >
              {/* Stars */}
              <div className="flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-500 text-lg"></i>
                ))}
              </div>

              {/* Quote */}
              <p className="text-gray-700 text-lg leading-relaxed italic">
                &ldquo;{review.quote}&rdquo;
              </p>

              {/* Author */}
              <div className="flex items-center gap-4 mt-auto">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-yellow-600 text-white font-black text-sm flex-shrink-0">
                  {review.initials}
                </div>
                <div>
                  <p className="font-bold text-gray-900">{review.name}</p>
                  <p className="text-sm text-gray-500">{review.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
